import { Dispatch, SetStateAction } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import CloseIcon from 'app/components/Icons/CloseIcon';

import { closeBtn, dialogActions, dialogTitle, paperProps } from './CheckModal.sx';

interface Props {
  open: boolean;
  title: string;
  showText?: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  approveAction: () => void;
}

const CheckModal = (props: Props) => {
  const { open, title, showText, close, approveAction } = props;

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: paperProps,
      }}
      onClose={() => {
        close(false);
      }}
    >
      <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
        <Button
          color={'tertiary'}
          onClick={() => {
            close(false);
          }}
          sx={closeBtn}
        >
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pl: '40px',
          gap: '16px',
        }}
      >
        <img src="/images/alert.svg" alt="alert" width="64" height="64" />
        <Typography textAlign="center" fontWeight={400} fontSize={20}>
          {title}
        </Typography>
        {showText && (
          <Typography fontWeight={500} fontSize={20}>
            Əminsiniz mi?
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={dialogActions}>
        <Button onClick={approveAction}>Bəli</Button>
        <Button
          color={'secondary'}
          sx={{ ml: '0 !important' }}
          onClick={() => {
            close(false);
          }}
        >
          İmtina et
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheckModal;
